import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, ShoppingBagIcon, XIcon } from "lucide-react";
import { product } from "../data/product";
const links = [{
  href: "#bundle",
  label: "Il bundle"
}, {
  href: "#dentro",
  label: "Cosa trovi all'interno"
}, {
  href: "#bonus",
  label: "I 5 bonus"
}, {
  href: "#faq",
  label: "Domande frequenti"
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line/60 bg-white" data-id="element-93" data-mp="2wl8ptle57kq5">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:h-16 sm:px-6" data-id="element-94" data-mp="2wj5ow6bgc76n">
        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? "Chiudi menu" : "Apri menu"} className="-ml-2 rounded-full p-2 text-wine focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose" data-id="element-95" data-mp="31e1s82m52gz2">
          {open ? <XIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-96" data-mp="2wkupj2u89zai" /> : <MenuIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-97" data-mp="2wlm7hauwjyib" />}
        </button>
        <a href="#top" className="font-serif text-lg font-semibold tracking-tight text-wine sm:text-xl" data-id="element-98" data-mp="2rli1iermem6c">
          {product.name}
        </a>
        <a href="#acquista" aria-label="Vai alla sezione di acquisto" className="-mr-2 rounded-full p-2 text-wine focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose" data-id="element-99" data-mp="2mmx0id4jnygu">
          <ShoppingBagIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-100" data-mp="3ac96l44krqex" />
        </a>
      </div>
      <AnimatePresence data-id="element-101" data-mp="3aelo5g6f7yrg">
        {open && <motion.nav initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-b border-line bg-white shadow-lg" aria-label="Navigazione principale" data-id="element-102" data-mp="35khfmshibio9">
            <ul className="mx-auto max-w-6xl px-4 py-2 sm:px-6" data-id="element-103" data-mp="1rdti6deuavct">
              {links.map(l => <li key={l.href} data-id="element-104" data-mp="1wceei1qz0uvz">
                  <a href={l.href} onClick={() => setOpen(false)} className="block border-b border-line/60 py-3.5 font-medium text-wine last:border-0" data-id="element-105" data-mp="1wbcuv8vw302n">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}